import script from "./ImagePolygonOutline.vue?vue&type=script&lang=ts&setup=true"
export * from "./ImagePolygonOutline.vue?vue&type=script&lang=ts&setup=true"

import "./ImagePolygonOutline.vue?vue&type=style&index=0&id=4dff8cbd&lang=scss&scoped=true"

import exportComponent from "D:\\huishi-ppt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dff8cbd"]])

export default __exports__